import { Component, Input } from '@angular/core';

import { isPedidoNaoConfirmado, isPedidoConfirmado, isPedidoConfirmandoERP, isPedidoAbertoERP, isPedidoEmAnalise, isPedidoAprovado, isPedidoReprovado, isPedidoCancelado, isPedidoFaturado, isPedidoFaturadoParcial, isPedidoProducao, isPedidoNaoLiberado, isPedidoRevisao, isPedidoStatusOutro } from '../pedido-status';

@Component({
    selector: 'sgt-pedido-status-badge',
    templateUrl: './pedido-status-badge.component.html',
    styleUrls: ['./pedido-status-badge.component.less']
})
export class PedidoStatusBadgeComponent {
    /** Status do Pedido */
    @Input() status: number;

    /** Verifica se o status do pedido é igual a Não Confirmado */
    isNaoConfirmado(): boolean {
        return isPedidoNaoConfirmado(this.status);
    }

    /** Verifica se o status do pedido é igual a Não Liberado */
    isNaoLiberado(): boolean {
        return isPedidoNaoLiberado(this.status);
    }

    /** Verifica se o status do pedido é igual a Confirmado */
    isConfirmado(): boolean {
        return isPedidoConfirmado(this.status);
    }

    /** Verifica se o status do pedido é igual a Confirmando ERP */
    isConfirmandoERP(): boolean {
        return isPedidoConfirmandoERP(this.status);
    }

    /** Verifica se o status do pedido é igual a Aberto ERP */
    isAbertoERP(): boolean {
        return isPedidoAbertoERP(this.status);
    }

    /** Verifica se o status do pedido é igual a Em Análise */
    isEmAnalise(): boolean {
        return isPedidoEmAnalise(this.status);
    }

    /** Verifica se o status do pedido é igual a Aprovado */
    isAprovado(): boolean {
        return isPedidoAprovado(this.status);
    }

    /** Verifica se o status do pedido é igual a Reprovado */
    isReprovado(): boolean {
        return isPedidoReprovado(this.status);
    }

    /** Verifica se o status do pedido é igual a Produção */
    isProducao(): boolean {
        return isPedidoProducao(this.status);
    }

    /** Verifica se o status do pedido é igual a Faturado */
    isFaturado(): boolean {
        return isPedidoFaturado(this.status);
    }

    /** Verifica se o status do pedido é igual a Faturado Parcial */
    isFaturadoParcial(): boolean {
        return isPedidoFaturadoParcial(this.status);
    }

    /** Verifica se o status do pedido é igual a Cancelado */
    isCancelado(): boolean {
        return isPedidoCancelado(this.status);
    }

    /** Verifica se o status do pedido é igual a Revisão */
    isRevisao(): boolean {
        return isPedidoRevisao(this.status);
    }

    /** Verifica se o status do pedido é igual a Outro */
    isOutro(): boolean {
        return isPedidoStatusOutro(this.status);
    }
}
